export default "__VITE_ASSET__sO06bTJo__"